<template>
  <div class="header-nav-news">
    <!-- <b-link
      v-ripple.400="'rgba(113, 102, 240, 0.15)'"
      variant="flat-primary"
      size="sm"
      @click="navigateDashboard"
      class="btn-sm btn-nav-link"
      v-b-tooltip.hover.v-secondary
      title="Dashboard"
    >
      <feather-icon icon="PieChartIcon" class="mr-50" />
      <span class="align-middle">Dashboard</span>
    </b-link> -->
    <b-link
      size="sm"
      v-ripple.400="'rgba(113, 102, 240, 0.15)'"
      variant="flat-primary"
      class="btn-sm btn-nav-link"
      @click="$emit('action-import-calendar')"
      v-b-tooltip.hover.v-secondary
      :title="$t('NEWS_ACTIONS.Import_Calendar')"
    >
      <feather-icon icon="FilePlusIcon" class="mr-50" />
      <span class="align-middle">{{$t('NEWS_ACTIONS.Import_Calendar')}}</span>
    </b-link>
    <b-link
      v-ripple.400="'rgba(113, 102, 240, 0.15)'"
      variant="flat-primary"
      size="sm"
      class="btn-sm btn-nav-link"
      @click="$emit('action-create-news')"
      v-b-tooltip.hover.v-secondary
      :title="$t('NEWS_ACTIONS.Add')"
    >
      <feather-icon icon="PlusIcon" class="mr-50" />
      <span class="align-middle">{{$t('NEWS_ACTIONS.Add')}}</span>
    </b-link>
    <!-- <b-link
        class="btn-sm btn-nav-link"
      v-ripple.400="'rgba(113, 102, 240, 0.15)'"
      @click="$emit('action-flashes')"
      v-b-tooltip.hover.v-secondary
      title="Publicação rápida"
    >
      <feather-icon icon="ZapIcon" class="mr-50" />
      <span class="align-middle">Pisca</span>
    </b-link> -->
    <b-link
      size="sm"
      v-ripple.400="'rgba(113, 102, 240, 0.15)'"
      variant="flat-primary"
      class="btn-sm btn-nav-link"
      @click="$emit('action-media')"
      v-b-tooltip.hover.v-secondary
      :title="$t('NEWS_ACTIONS.Media')"
    >
      <feather-icon icon="ImageIcon" class="mr-50" />
      <span class="align-middle">{{$t('NEWS_ACTIONS.Media')}}</span>
    </b-link>
    <b-link
      size="sm"
      v-ripple.400="'rgba(113, 102, 240, 0.15)'"
      variant="flat-primary"
      v-b-tooltip.hover.v-secondary
      :title="$t('NEWS_ACTIONS.Schedule_')"
      class="btn-sm btn-nav-link btn-nav-link-calendar"
      :class="{'selected': calendarParams}"
      @click="$emit('action-calendar')"
    >
      <feather-icon icon="CalendarIcon" class="mr-50" />
      <span class="align-middle">{{$t('NEWS_ACTIONS.Schedule_')}}</span>
    </b-link>
    
    <agency/>
    <user-dropdown @open-user-modal="openUserModal"></user-dropdown>
    <!-- User Modal -->
    <b-modal
      modal-class="modal-primary custom-user-modal"
      ref="user-modal"
      size="lg"
      centered
      no-close-on-backdrop
    >
      <div class="d-block">
        <account-setting></account-setting>
      </div>
    </b-modal>
    <!-- /User Modal -->
  </div>


</template>

<script>
import {BLink, VBTooltip, BModal } from "bootstrap-vue";
import UserDropdown from '@/layouts/components/UserDropdown.vue'
import Agency from '@/layouts/components/Agency.vue'
import Ripple from "vue-ripple-directive";
import AccountSetting from '@/views/pages/account-setting/AccountSetting.vue';

export default {
  components: {
    BModal,
    BLink,
    UserDropdown,
    AccountSetting,
    Agency
  },
  directives: {
    Ripple,
    "b-tooltip": VBTooltip,
  },
  computed: {
    calendarParams() {
      return this.$route.query.calendar;
    }
  },
  methods: {
    openUserModal() {
      this.$refs["user-modal"].show();
    },
    navigateDashboard() {
      const currentRouteQuery = JSON.parse(JSON.stringify(this.$route.query));
      currentRouteQuery.dashboard = true;
      this.$router.replace({ query: currentRouteQuery }).catch(() => {});
    }
  }
};
</script>

<style>
</style>
